/*
 * @Author: your name
 * @Date: 2020-08-11 21:01:30
 * @LastEditTime: 2022-11-09 16:23:40
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/router/index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import { getUrlParam, widthOfDeviceIsMobile } from 'utils'

import { tabAdminRouterList } from './tab-admin'
import tabUser from './tab-user'
import { redirectList } from './redirect-list'
import { otherAction } from '@/api/product'
import { _generateUuidOrderId } from 'utils/uuid'
import { _ } from 'core-js'
import store from '@/store'
import componentPreloader from './componentPreloader'
import { menuAddressFor } from '@/utils/menu/menuAddress'
import { isSingleStoreLanding } from '@/utils/menu/qrEntry'
import { parseRouteQuery } from '@/utils/urlQuery'

Vue.use(VueRouter)
Vue.use(Meta)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 多版本菜单 B6（U-B6-2 review 第 2 轮 G13）：replace 与 push 同样包一层。守卫一重定向（菜单预览码透传守卫、老的 /online/、ta 等），
// vue-router 3.6.5 放弃原来那次 replace、改发一次 push，原来的 replace promise 以「Redirected … via a navigation guard」拒掉 —— 以前没人接
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

/**
 * meta:
 * barShow {Boolean} Whether to display the head navigation bar
 * barTitle {String} Header navigation bar title
 * showArrow {Boolean} The true header displays the return to the previous page button, and the false header displays the menu button
 */
/**
 * meta:
 * barShow {Boolean} 是否显示头部导航栏
 * barTitle {String} 头部导航栏的标题
 * showArrow {Boolean} true 头部是否显示返回上一页按钮， false 代表显示
 */

let routes = [

  // special - need to remove in future
  {
    path: '/v/ssp_new_york_burger/home/t/n-t',
    params: { venueId: 'ssp_new_york_burger' },
    props: true,
    redirect: {
      name: 'venue-home-pick',
      params: { venueId: 'ssp_new_york_burger' }
    }
  },
  /**
   * Display the restaurant terms of use page
   * @param showTermsDialog {Boolean} Display terms pop-up
   */
  /**
   * 展示餐厅使用条款的页面
   * @param showTermsDialog {Boolean} 显示条款的弹窗
   */
  {
    path: '/venue/terms',
    alias: '/online/venue/terms',
    name: 'venue-terms',
    props: {
      showTermsDialog: true
    },
    component: () => import('views/venue-home/component/TermsDialog/index'),
  },

  {
    path: '/s/delivery',
    name: 'delivery/pickup',
    component: () => import('views/sales'),
  },

  {
    path: '/s/aov',
    name: 'aov',
    component: () => import('views/sales'),
  },

  /**
   * Display restaurant privacy details page
   * @param showTermsDialog {Boolean} Show privacy pop-up
   */
  /**
   * 展示餐厅隐私详情的页面
   * @param showTermsDialog {Boolean} 显示隐私的弹窗
   */
  {
    path: '/venue/privacy',
    alias: '/online/venue/privacy',
    name: 'venue-privacy',
    props: {
      showPrivacyDialog: true
    },
    component: () => import('views/venue-home/component/PrivacyDialog/index'),
  },

  /**
   * PC adapter page
   */
  /**
   * pc 端适配页
   */
  {
    path: '/pc',
    alias: '/online/pc',
    component: () => import('views/pc'),
  },

  /**
   * VenueList display page of venueGroup
   * @param venueGroupId {String} venueGroupId
   */
  /**
   * venueGroup 的 venueList 展示页
   * @param venueGroupId {String} venueGroup 的 id
   */
  {
    path: '/vg/:venueGroupId',
    alias: '/online/vg/:venueGroupId',
    props: true,
    name: 'venue-group',
    meta: {
      barShow: false,
      barTitle: '22',
      showArrow: true,
    },
    component: () => import('views/venue-group')
  },

  {
    path: '/vgs/:venueSubGroupId',
    alias: '/online/vgs/:venueSubGroupId',
    props: true,
    name: 'venue-sub-group',
    meta: {
      barShow: false,
      barTitle: '22',
      showArrow: true,
    },
    component: () => import('views/venue-sub-group')
  },

  /**
   * Menu's menu home page
   * @param venueId {String} venueId
   */
  /**
   * venue 的菜品列表主页
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/home/p',
    alias: ['/online/v/:venueId/home/p', '/r/v/:venueId/home/p', '/v/o/:venueId/home/p'],
    props: true,
    name: 'venue-home-pick',
    meta: {
      barShow: true,
      barTitle: 'Nathan Burgers',
      showArrow: true,
    },
    component: () => import('views/venue-home')
  },

  /**
   * SP Mode - Menu's menu home page (pickup mode)
   * SP 模式 - venue 的菜品列表主页（自取模式）
   * @param venueId {String} venueId
   */
  {
    path: '/v/sp/:venueId/home/p',
    props: true,
    name: 'venue-home-pick-sp',
    meta: {
      barShow: true,
      barTitle: 'Nathan Burgers',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/venue-home')
  },

  /**
   * SP Mode - Menu's menu home page (with table number)
   * SP 模式 - venue 的菜品列表主页（附带桌号）
   * @param venueId {String} venueId
   * @param number {String} Table No
   */
  {
    path: '/v/sp/:venueId/home/t/:number',
    props: true,
    name: 'venue-home-table-sp',
    meta: {
      barShow: true,
      barTitle: 'Nathan Burgers',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/venue-home')
  },

  /**
   * SP Mode - Menu's menu home page (with table number, without "home" in path)
   * SP 模式 - venue 的菜品列表主页（附带桌号，路径不含 "home"）
   * @param venueId {String} venueId
   * @param number {String} Table No
   */
  {
    path: '/v/sp/:venueId/t/:number',
    props: true,
    name: 'venue-home-table-sp-alt',
    meta: {
      barShow: true,
      barTitle: 'Nathan Burgers',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/venue-home')
  },

  /**
   * SP Mode - Menu's menu home page (without table number)
   * SP 模式 - venue 的菜品列表主页（不带桌号）
   * @param venueId {String} venueId
   */
  {
    path: '/v/sp/:venueId/t',
    props: true,
    name: 'venue-home-no-table-sp',
    meta: {
      barShow: true,
      barTitle: 'Nathan Burgers',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/venue-home')
  },

  /**
   * SP Mode - Product detail page (pickup mode)
   * SP 模式 - 产品详情页（自取模式）
   */
  {
    path: '/v/sp/:venueId/product/p/:productId',
    name: 'product-detail-pick-sp',
    props: true,
    meta: {
      barShow: true,
      barTitle: 'product-detail',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/product-detail'),
  },

  /**
   * SP Mode - Product detail page (with table number)
   * SP 模式 - 产品详情页（附带桌号）
   */
  {
    path: '/v/sp/:venueId/product/t/:number/:productId',
    name: 'product-detail-table-sp',
    props: true,
    meta: {
      barShow: true,
      barTitle: 'product-detail-table',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/product-detail'),
  },

  /**
   * SP Mode - Cart page (pickup mode)
   * SP 模式 - 购物车页面（自取模式）
   */
  {
    path: '/v/sp/:venueId/cart/p',
    props: true,
    name: 'cart-pick-sp',
    meta: {
      barShow: true,
      barTitle: 'My cart',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/cart')
  },

  /**
   * SP Mode - Cart page (with table number)
   * SP 模式 - 购物车页面（附带桌号）
   */
  {
    path: '/v/sp/:venueId/cart/t/:number',
    props: true,
    name: 'cart-table-sp',
    meta: {
      barShow: true,
      barTitle: 'My cart',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/cart')
  },

  /**
   * SP Mode - Contact details page
   * SP 模式 - 联系方式页
   */
  {
    path: '/v/sp/:venueId/contact-details',
    name: 'contact-details-sp',
    meta: {
      barShow: true,
      barTitle: 'Contact details',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/contact-details')
  },

  /**
   * SP Mode - Payment page
   * SP 模式 - 支付页面
   */
  {
    path: '/v/sp/:venueId/payment',
    name: 'payment-sp',
    meta: {
      barShow: true,
      barTitle: 'Select a payment method',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/payment')
  },

  /**
   * SP Mode - Pay success page
   * SP 模式 - 支付成功页
   */
  {
    path: '/v/sp/:venueId/pay/:orderId',
    name: 'pay-sp',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/pay')
  },

  /**
   * SP Mode - Order detail page
   * SP 模式 - 订单详情页
   */
  {
    path: '/v/sp/:venueId/my-order/:orderId',
    name: 'my-order-sp',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/pay')
  },

  /**
   * SP Mode - Card detail page
   * SP 模式 - 信用卡详情页
   */
  {
    path: '/v/sp/:venueId/card-detail',
    name: 'card-detail-sp',
    meta: {
      barShow: true,
      barTitle: 'Card details',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/card-detail')
  },

  /**
   * Menu menu homepage (without table number)
   * @param venueId {String} venueId
   */
  /**
   * venue 的菜品列表主页（不带桌号）
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/t',
    alias: ['/online/v/:venueId/t', '/r/v/:venueId/t'],
    props: true,
    name: 'venue-home-no-table',
    meta: {
      barShow: true,
      barTitle: 'Nathan Burgers',
      showArrow: true,
    },
    component: () => import('views/venue-home')
  },

  /**
   * Venue's product list homepage (with table number)
   * @param venueId {String} venueId
   * @param number {String} Table No
   */
  /**
   * venue 的菜品列表主页（附带桌号）
   * @param venueId {String} venue 的 id
   * @param number {String} 桌号
   */
  {
    path: '/v/:venueId/home/t/:number',
    alias: ['/online/v/:venueId/home/t/:number', '/r/v/:venueId/home/t/:number'],
    props: true,
    name: 'venue-home-table',
    meta: {
      barShow: true,
      barTitle: 'Nathan Burgers',
      showArrow: true,
    },
    component: () => import('views/venue-home')
  },

  /**
   * Venue's menu details page
   * @param venueId {String} venueId
   * @param productId {String} productId
   */
  /**
   * venue 的菜品详情页
   * @param venueId {String} venue 的 id
   * @param productId {String} 菜品的 id
   */
  {
    path: '/v/:venueId/product/p/:productId',
    alias: ['/online/v/:venueId/product/p/:productId', '/r/v/:venueId/product/p/:productId', '/v/o/:venueId/product/p/:productId'],
    name: 'product-detail-pick',
    props: true,
    meta: {
      barShow: true,
      barTitle: 'product-detail',
      showArrow: true,
    },
    component: () => import('views/product-detail'),
  },

  /**
   * Venue's menu details page (with table number)
   * @param venueId {String} venueId
   * @param number {String} Table No
   * @param productId {String} productId
   */
  /**
   * venue 的菜品详情页（附带桌号）
   * @param venueId {String} venue 的 id
   * @param number {String} 桌号
   * @param productId {String} 菜品的 id
   */
  {
    path: '/v/:venueId/product/t/:number/:productId',
    alias: ['/online/v/:venueId/product/t/:number/:productId', '/r/v/:venueId/product/t/:number/:productId'],
    name: 'product-detail-table',
    props: true,
    meta: {
      barShow: true,
      barTitle: 'product-detail-table',
      showArrow: true,
    },
    component: () => import('views/product-detail'),
  },

  /**
   * The shopping cart page of venue
   * @param venueId {String} venueId
   */
  /**
   * venue 的购物车页面
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/cart/p',
    alias: ['/online/v/:venueId/cart/p', '/v/o/:venueId/cart/p'],
    props: true,
    name: 'cart-pick',
    meta: {
      barShow: true,
      barTitle: 'My cart',
      showArrow: true,
    },
    component: () => import('views/cart')
  },

  /**
   * The shopping cart page of sub group
   * @param venueSubGroupId {String} venueSubGroupId
   */
  /**
   * subgroup 的购物车页面
   * @param venueSubGroupId {String} venueSubGroupId
   */
  {
    path: '/vgs/:venueSubGroupId/cart/p',
    alias: ['/online/vgs/:venueSubGroupId/cart/p', '/vgs/o/:venueSubGroupId/cart/p'],
    props: true,
    name: 'venue-sub-group-cart-pick',
    meta: {
      barShow: true,
      barTitle: 'My cart',
      showArrow: true,
    },
    component: () => import('views/venue-sub-group/cart')
  },

  /**
   * The shopping cart page of venue (with table number)
   * @param venueId {String} venueId
   * @param number {String} Table No
   */
  /**
   * venue 的购物车页面（附带桌号）
   * @param venueId {String} venue 的 id
   * @param number {String} 桌号
   */
  {
    path: '/v/:venueId/cart/t/:number',
    alias: '/online/v/:venueId/cart/t/:number',
    props: true,
    name: 'cart-table',
    meta: {
      barShow: true,
      barTitle: 'My cart',
      showArrow: true,
    },
    component: () => import('views/cart')
  },

  /**
   * The shopping cart page of venue sub group (with table number)
   * @param venueSubGroupId {String} venueSubGroupId
   * @param number {String} Table No
   */
  /**
   * venueSubgroup 的购物车页面（附带桌号）
   * @param venueSubGroupId {String} venueSubGroupId
   * @param number {String} 桌号
   */
  {
    path: '/vgs/:venueSubGroupId/cart/t/:number',
    alias: '/online/vgs/:venueSubGroupId/cart/t/:number',
    props: true,
    name: 'venue-sub-group-cart-table',
    meta: {
      barShow: true,
      barTitle: 'My cart',
      showArrow: true,
    },
    component: () => import('views/venue-sub-group/cart')
  },

  /**
   * The user of avenue fills in the contact information page
   * @param venueId {String} venueId
   */
  /**
   * venue 的用户填写联系方式页
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/contact-details',
    alias: ['/online/v/:venueId/contact-details', '/v/o/:venueId/contact-details'],
    name: 'contact-details',
    meta: {
      barShow: true,
      barTitle: 'Contact details',
      showArrow: true,
    },
    component: () => import('views/contact-details')
  },

  /**
   * The user of sub group fills in the contact information page
   * @param venueId {String} venueId
   */
  /**
   * sub group 的用户填写联系方式页
   * @param venueId {String} venue 的 id
   */
  {
    path: '/vgs/:venueSubGroupId/contact-details',
    alias: ['/online/vgs/:venueSubGroupId/contact-details', '/vgs/o/:venueSubGroupId/contact-details'],
    name: 'venue-sub-group-contact-details',
    props: true,
    meta: {
      barShow: true,
      barTitle: 'Contact details',
      showArrow: true,
    },
    component: () => import('views/contact-details')
  },

  /**
   * Users of venue fill in the payment method page
   * @param venueId {String} venueId
   */
  /**
   * venue 的用户填写支付方式页
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/payment',
    alias: ['/online/v/:venueId/payment', '/v/o/:venueId/payment'],
    name: 'payment',
    meta: {
      barShow: true,
      barTitle: 'Select a payment method',
      showArrow: true,
    },
    component: () => import('views/payment')
  },

  /**
   * Users of venue subgroup fill in the payment method page
   * @param venueId {String} venueId
   */
  /**
   * venue subgroup 的用户填写支付方式页
   * @param venueId {String} venue 的 id
   */
  {
    path: '/vgs/:venueSubGroupId/payment',
    alias: ['/online/vgs/:venueSubGroupId/payment', '/vgs/o/:venueSubGroupId/payment'],
    name: 'venue-sub-group-payment',
    props: true,
    meta: {
      barShow: true,
      barTitle: 'Select a payment method',
      showArrow: true,
    },
    component: () => import('views/payment')
  },

  /**
   * @param venueId {String} venueId
   * @param orderId {String} orderId
   */
  /**
   * 支付成功展示页
   * @param venueId {String} venue 的 id
   * @param orderId {String} order 的 id
   */
  {
    path: '/v/:venueId/pay/:orderId',
    alias: ['/online/v/:venueId/pay/:orderId', '/v/o/:venueId/pay/:orderId'],
    name: 'pay',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
    },
    component: () => import('views/pay')
  },

  /**
   * Order Details Page
   * @param venueId {String} venueId
   * @param orderId {String} orderId
   */
  /**
   * 订单详情页
   * @param venueId {String} venue 的 id
   * @param orderId {String} order 的 id
   */
  {
    path: '/v/:venueId/my-order/:orderId',
    alias: ['/online/v/:venueId/my-order/:orderId', '/v/o/:venueId/my-order/:orderId'],
    name: 'my-order',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
    },
    component: () => import('views/pay')
  },

  {
    path: '/venue/:venueId/order-status/:orderId',
    alias: ['/online/venue/:venueId/order-status/:orderId', '/v/o/:venueId/order-status/:orderId'],
    name: 'venue-order-status',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
    },
    component: () => import('views/venue-sub-group/orderStatus')
  },

  /**
   * Venue Subgroup Order Details Page
   * @param venueSubGroupId {String} venueSubGroupId
   * @param orderId {String} orderId
   */
  /**
   * 订单详情页
   * @param venueSubGroupId {String} venueSubGroupId 的 id
   * @param orderId {String} order 的 id
   */
  {
    path: '/vgs/:venueSubGroupId/my-order/:orderId',
    alias: ['/online/vgs/:venueSubGroupId/my-order/:orderId', '/vgs/o/:venueId/my-order/:orderId'],
    name: 'venue-sub-group-my-order',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
    },
    component: () => import('views/venue-sub-group/orderDetail')
  },

  {
    path: '/vgs/:venueSubGroupId/order-status/:orderId',
    alias: ['/online/vgs/:venueSubGroupId/order-status/:orderId', '/vgs/o/:venueSubGroupId/order-status/:orderId'],
    name: 'venue-sub-group-my-order-status',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
    },
    component: () => import('views/venue-sub-group/orderStatus')
  },

  /**
   * Display page of successful payment
   * @param venueId {String} venueId
   * @param orderId {String} orderId
   */
  /**
   * 支付成功展示页
   * @param venueId {String} venue 的 id
   * @param orderId {String} order 的 id
   */
  {
    path: '/vgs/:venueSubGroupId/pay/:orderId',
    alias: ['/online/vgs/:venueSubGroupId/pay/:orderId', '/vgs/o/:venueSubGroupId/pay/:orderId'],
    name: 'venue-sub-group-my-order',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
    },
    component: () => import('views/venue-sub-group/orderDetail')
  },

  /**
   * User's History Order Page
   * @param venueId {String} venueId
   */
  /**
   * 用户的历史订单页
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/order-history',
    alias: ['/online/v/:venueId/order-history', '/v/o/:venueId/order-history'],
    name: 'order-history',
    meta: {
      barShow: true,
      barTitle: 'Order history',
      showArrow: true,
    },
    component: () => import('views/order-history')
  },

  /**
   * SP Mode - Order history page
   * SP 模式 - 订单历史页面
   * @param venueId {String} venueId
   */
  {
    path: '/v/sp/:venueId/order-history',
    name: 'order-history-sp',
    meta: {
      barShow: true,
      barTitle: 'Order history',
      showArrow: true,
      isSpMode: true,
    },
    component: () => import('views/order-history')
  },

  {
    path: '/vgs/:venueSubGroupId/order-history',
    alias: ['/online/vgs/:venueSubGroupId/order-history', '/vgs/o/:venueSubGroupId/order-history'],
    name: 'venue-sub-group-order-history',
    props: true,
    meta: {
      barShow: true,
      barTitle: 'Order history',
      showArrow: true,
    },
    component: () => import('views/venue-sub-group/orderHistory')
  },

  /**
   * User's Recovery Order History Login Page
   * @param venueId {String} venueId
   */
  /**
   * 用户的恢复历史订单登录页
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/login',
    alias: ['/online/v/:venueId/login', '/v/o/:venueId/login'],
    name: 'login',
    component: () => import('views/login'),
    children: [
      /**
       * User's Recovery Order History Login Page - Enter Mobile Number Page
       */
      /**
       * 用户的恢复历史订单登录页 - 输入手机号页
       */
      {
        path: 'enter-phone-number',
        name: 'enter-phone-number',
        component: () => import('views/login/enterPhoneNumber'),
        meta: {
          barShow: true,
          barTitle: 'Order history',
          showArrow: true,
        },
      },
      /**
       * User's Recovery Order History Login Page - Enter Verification Code Page
       */
      /**
       * 用户的恢复历史订单登录页 - 输入验证码页
       */
      {
        path: 'verification-code',
        name: 'verification-code',
        component: () => import('views/login/verificationCode'),
        meta: {
          barShow: true,
          barTitle: 'Order history',
          showArrow: true,
        },
      }
    ]
  },

  /**
   * The user fills in the credit card page
   * @param venueId {String} venueId
   */
  /**
   * 用户填写信用卡页面
   * @param venueId {String} venue 的 id
   */
  {
    path: '/v/:venueId/card-detail',
    alias: ['/online/v/:venueId/card-detail', '/v/o/:venueId/card-detail'],
    name: 'card-detail',
    meta: {
      barShow: true,
      barTitle: 'Card details',
      showArrow: true,
    },
    component: () => import('views/card-detail')
  },

  /**
   * The user fills in the credit card page
   * @param venueId {String} venueId
   */
  /**
   * 用户填写信用卡页面
   * @param venueId {String} venue 的 id
   */
  {
    path: '/vgs/:venueSubGroupId/card-detail',
    alias: ['/online/vgs/:venueSubGroupId/card-detail', '/vgs/o/:venueSubGroupId/card-detail'],
    name: 'venue-sub-group-card-detail',
    props: true,
    meta: {
      barShow: true,
      barTitle: 'Card details',
      showArrow: true,
    },
    component: () => import('views/card-detail')
  },

  /**
   * Independent survey page
   * @param venueId {String}venueId
   * @param userId {String} userId - device id
   * @param surveyId {string} survey id - beginning campaign or list of survey
   */
  /**
   * 独立的 survey 页面
   * @param venueId {String} venue 的 id
   * @param userId {String} user 的 id - device id
   * @param surveyId {string} survey id - beginning campaign or list of survey
   */
  {
    path: '/v/:venueId/survey/:userId/:surveyId',
    name: 'survey',
    props: true,
    meta: {
      barShow: true,
      showArrow: true,
    },
    component: () => import('views/survey')
  },

]

const errorRouterList = [
  // 404 page
  {
    path: '/not-find-venue',
    alias: '/online/not-find-venue',
    name: 'not-find-venue',
    component: () => import('views/error')
  },
  {
    path: '*',
    name: 'error-page',
    component: () => import('views/error')
  }
]

// Redirect route list
// 重定向路由列表
const routesRedirectList = redirectList

routes = routes
  .concat(routesRedirectList) // Redirect to the first position   // 重定向要放在第一个位置
  .concat(tabAdminRouterList)
  .concat(tabUser)
  .concat(errorRouterList) // The error page should be placed at the last position   // 错误页面要放在最后位置

const router = new VueRouter({
  mode: 'history',
  // 多版本菜单 N35-B2 第 5 轮复核（Codex P1）：读 query 用与 vue-router 3.6.5 相同的办法（utils/urlQuery.js parseRouteQuery）。
  // 服务器构建装的 3.3.4 自带的那份遇到一个解不开的值（`label=5%`、下面 splicingQuery 拼回来的 `tableNumber=5%`）就把整串 query 丢掉 ——
  // 进店参数 mmEntry 与点单链接码 menuLink 一起丢，补参数的守卫还会来回打转不落地；3.6.5 只把那一个值原样留下。换成这一份两版一致。
  parseQuery: parseRouteQuery,
  scrollBehavior: (to, from) => {
    const isScrollTo = to.path === from.path ? {} : {
      x: 0,
      y: 0
    }
    return isScrollTo
  },
  routes
})

/**
 * 这一页（这一次整页加载）的第一个导航落地了没有 —— 守卫用它判「整页加载」（多版本菜单 N35-B2 第 5 轮）。
 *
 * 原来写的是 `from === VueRouter.START_LOCATION`：`START_LOCATION` 是 vue-router **3.5.0** 才导出的，而测试机与生产的构建不按
 * pnpm-lock 装依赖，部署包里是 **3.3.4**（2026-10-24 bug 环境实测；本地 pnpm 装的是 3.6.5）—— 在那里它是 undefined、判断恒为 false，
 * 进店参数 mmEntry 一次都写不进地址，Counter / 指定桌菜单在扫码端全不生效，本地测试却全绿。现在只用 3.x 一直都有的 `afterEach`：
 * - 「落地」= 第一次走到 afterEach。vue-router 在同一个同步回调里先把 current 从 START 换成落地的路由、紧接着调 afterEach，
 *   所以「还没走过 afterEach」与原来的 `from === START` 是同一件事：
 *   - 第一个导航被守卫重定向（`next(location)`，我们自己写进店参数那一下也是）：被重定向的那一次没落地，重定向去的那一次
 *     from 仍是 START、这里也仍是 false ⇒ 第二遍守卫照样算整页加载（R4B5-2 清旧 subGroupId 就在第二遍）；
 *   - 第一个导航被 `next(false)` 中止 / 抛错：同样没落地，current 还是 START ⇒ 下一次导航仍算整页加载，两种写法一致；
 *   - 没有用 3.4+ / 3.5+ 才有的 START_LOCATION、isNavigationFailure、NavigationFailureType、addRoute、getRoutes。
 * - 排在所有 afterEach 之前（紧跟着建路由器注册；组件预加载、统计、性能上报的 afterEach 都在它后面），前面没有别的钩子会抛错挡住它。
 * - 模块级变量 = 一页一份：这个站只在浏览器里跑（没有服务端渲染，不存在多个请求共用一份模块），整页加载 = 模块重新执行 = 重新是 false。
 *   与 START 唯一的差别：3.6 起销毁最后一个根实例时 current 会被重置回 START，这里不会 —— 这个站的根实例从不销毁。
 */
let firstNavigationLanded = false
router.afterEach(() => {
  firstNavigationLanded = true
})

/**
 * 守卫要改写地址时，是改写地址栏现在这一条（replace），还是压一条新的（push）。
 * 浏览器后退 / 前进（popstate）落到的那一条要补参数 ⇒ 这一次导航里的**每一次**守卫重定向都 replace 改写这一条；
 * push 会截掉前进的那几条，再后退又落回这条、再 push 一次，后退键就卡住了（review 第 4 轮 R4B5-5，B25 复核 Codex P2）。
 * 站内 push / replace 时地址栏还是上一页，认不上 ⇒ 照旧 push（站内 router.replace 被守卫补参数时变 push 是既有问题，已登记）。
 *
 * - `rewritingRoute`：这一遍守卫链里要「改写地址栏这一条」的 to（同一遍里各个 beforeEach 拿到的是同一个 route 对象）。
 *   第一个 beforeEach 每次导航都重算一次。
 * - `rewritingNext`：上一步 replace 重定向去的地址（当时的地址栏原样 + 规范化后的 fullPath）。重定向是一次新的导航、to 是新对象，
 *   守卫链再跑一遍时靠它认出「还是同一次后退」（地址栏仍是落到的那一条，to 是我们 replace 去的地址）。用一次就清。
 */
let rewritingRoute = null
let rewritingNext = null

/**
 * 这一次导航落到的就是地址栏这一条吗（浏览器后退 / 前进；整页加载的第一个导航也是）。
 * 拿地址栏原样字符串经 vue-router 自己的 match 规范化后与 to.fullPath 比 —— popstate 时 vue-router 正是这么算出 to 的；
 * 原样字符串直接比会漏掉写法不同的老地址：vue-router 读 query 时把 `+` 当空格、fullPath 再写成 `%20`
 * （`label=A+B` ⇒ `label=A%20B`），比不上就退回 push ⇒ 卡住。
 * 与 vue-router 版本无关（N35-B2 第 5 轮逐版本核过，3.3.4 与 3.6.5 两版都跑 `npm run test:router-compat`）：`getCurrentLocation` 两版都有
 * （3.3.4 先把路径 decodeURI、3.6.5 原样），popstate 时 to 也是拿同一个字符串 match 出来的，两边同一版本里自己跟自己比，结果一致。
 * @param {Object} to
 * @param {Object} from
 * @returns {Boolean}
 */
function rewritesCurrentEntry(to, from) {
  const pending = rewritingNext
  rewritingNext = null
  try {
    // 读地址栏也放进 try：3.3.4 的 getCurrentLocation 先 decodeURI 路径，路径里有解不开的 % 会抛（3.6.5 不解码、不抛）—— 认不出就当不是这一条（照旧 push）
    const address = router.history.getCurrentLocation()
    if (pending && pending.address === address && pending.fullPath === to.fullPath) return true
    return router.match(address, from).fullPath === to.fullPath
  } catch (e) {
    return false
  }
}

/**
 * 守卫重定向一律经它：这一次导航在改写地址栏这一条 ⇒ replace（并记下去哪，下一遍守卫接着 replace）；否则原样交给 next（push，
 * 或调用方自己给的 replace）。
 * @param {Object} to
 * @param {Object} from
 * @param {Function} next
 * @param {String|Object} location
 */
function redirectFrom(to, from, next, location) {
  if (rewritingRoute !== to) return next(location)
  const target = typeof location === 'string' ? { path: location } : location
  try {
    rewritingNext = { address: router.history.getCurrentLocation(), fullPath: router.match(target, from).fullPath }
  } catch (e) {
    rewritingNext = null
  }
  return next({ ...target, replace: true })
}

// 多版本菜单：地址里跟着走的三个键，一个守卫各自补（utils/menu/menuAddress.js；读的是上一页的地址，不写任何存储）——
// - 菜单预览码 previewMenu（B6 U-B6-3，owner D98②）：页面里的 $router.push 几乎都不带 query，不补的话进购物车码就丢了 ——
//   购物车里是预览菜单的东西，下单却不带 X-Preview-Menu，码一失效就会按主菜单下出真单（D80 要防的）。kiosk guards.ts 同口径。
//   ⚠️ 推论：站内跳转退不出预览；退出只能整页打开不带码的地址。只有它要补时，改写成的地址与 B6 逐字节相同。
// - 点单链接码 menuLink（N35-B5）：同一口径。
// - 进店参数 mmEntry（N35-B2 review 第 4 轮，Q16 / Q17 / Q19）：整页加载的第一个导航落在入口地址（扫码 / 链接）时按地址算出
//   table / gtable / counter，用一次 replace 写进地址（不多一条历史）；之后站内跳转只在同一家店内补，Custom Flows 永远去掉。
//   刷新、书签、后退前进、桌面 pc.html 外壳（它拿的就是补过参数的地址）都只是「打开某个地址」，身份照那个地址。
// 排在所有守卫之前：老守卫的重定向（/online/、ta、tableNumber …）只拼 to.query，所以先补进 to，它们再原样带走；
// 桌面那条 pc.html 分支取的 to.fullPath 也已经带着进店参数。补过之后再判一次一定放行，不会死循环。
// review 第 4 轮 R4B5-5：浏览器后退 / 前进（popstate）时地址栏已经是 to 这一条 —— 要补参数就 replace 改写这一条；
//   push 会截掉前进的那几条，再按后退又落回这条没参数的、再 push 一次，后退键就卡住了（R4B5-1 那条坏地址就是这么卡的）。
//   B25 复核（Codex P2）两处补全，见下面 rewritesCurrentEntry / redirectFrom：认「落到的就是地址栏这一条」按规范化后的地址比；
//   同一次导航里后面的重定向（老守卫补 portal / ta / tableNumber / online / o / r / sp）也接着 replace。
// review 第 4 轮 R4B5-2：整页加载落在单店入口（地址上有进店参数 / 点单链接码，或落地本身是入口）⇒ 清掉上一次走合单留在持久化 vuex 里的
//   subGroupId（不清的话读菜单 / 下单一律当合单、不带 service 和码）。站内从合单页选进成员店不是整页加载，不动（qrEntry.js isSingleStoreLanding）。
// 「整页加载」= 这一页的第一个导航还没落地（上面 firstNavigationLanded；不用 VueRouter.START_LOCATION —— 服务器构建的 vue-router 3.3.4 没有它，N35-B2 第 5 轮）。
router.beforeEach((to, from, next) => {
  rewritingRoute = rewritesCurrentEntry(to, from) ? to : null
  const pageLoad = !firstNavigationLanded
  const carried = menuAddressFor(to, from, { pageLoad, state: store.state })
  if (carried) return redirectFrom(to, from, next, carried)
  if (pageLoad && store.state.venueHome && store.state.venueHome.subGroupId && isSingleStoreLanding(to)) {
    store.commit('saveSubGroupId', null)
  }
  next()
})

// Install component preloader
componentPreloader.install(router)

// Route Guard
// 路由守卫
router.beforeEach(async (to, from, next) => {
  // Redirect old official website paths to external site
  // 将旧官网路径重定向到外部网站
  if (to.path === '/' || to.path.startsWith('/site')) {
    window.location.href = 'https://www.mondoconnex.com'
    return
  }

  const routName = ['aov', 'delivery/pickup']
  await jumpDomainName()

  // If the current URL is for takeout, the jump URL will be automatically converted to takeout
  // 若现在是外卖的 url，那么跳转的 url 也自动转换成外卖的
  if (from.path.includes('/online/') && !to.path.includes('/online/')) {
    return redirectFrom(to, from, next, `/online${to.path}${splicingQuery(to, from)}`)
  }
  const fromIsTakeaway = from.path.includes('/v/o/')
  const toIsTakeaway = to.path.includes('/v/o/')
  // If the current URL is/v/o/, the skipped URL will also be automatically converted
  // 若现在是 /v/o/ 的 url，那么跳转的 url 也自动转换
  if (fromIsTakeaway && !toIsTakeaway) {
    return redirectFrom(to, from, next, `${to.path.replace('/v/', '/v/o/')}${splicingQuery(to, from)}`)
  }

  // If the current URL is read-only, the skipped URL will be automatically converted to read-only
  // 若现在是只读模式的 url，那么跳转的 url 也自动转换成只读模式的
  if (from.path.includes('/r/') && !to.path.includes('/r/')) {
    return redirectFrom(to, from, next, `/r${to.path}${splicingQuery(to, from)}`)
  }

  // If the current URL is SP mode, the skipped URL will also be automatically converted to SP mode
  // 若现在是 SP 模式的 url，那么跳转的 url 也自动转换成 SP 模式的
  const fromIsSpMode = from.path.includes('/v/sp/')
  const toIsSpMode = to.path.includes('/v/sp/')
  if (fromIsSpMode && !toIsSpMode && to.path.includes('/v/')) {
    return redirectFrom(to, from, next, `${to.path.replace('/v/', '/v/sp/')}${splicingQuery(to, from)}`)
  }

  // Every jump takes query - ta
  // 每次跳转都带走 query - ta
  if ((('ta' in from.query) && !('ta' in to.query)) || (from.query.portal && !to.query.portal)) {
    return redirectFrom(to, from, next, `${to.path}${splicingQuery(to, from)}`)
  }

  const isPC = !widthOfDeviceIsMobile()
  const isIframeEnv = self !== top
  if (isPC && !isIframeEnv) {
    const targetUrl = location.origin + to.fullPath
    location.href = location.origin + '/pc.html?iframeUrl=' + encodeURIComponent(targetUrl)
    return
  }

  // 若 url 中带有 tableNumber，则保存到 vuex（仅保存到 app.table，不污染 routerInfo.number）
  if (to?.query?.tableNumber) {
    store.commit('saveTable', to.query.tableNumber)
  }

  const tableNumber = store.state?.venueHome?.routerInfo?.number || from?.query?.tableNumber
  if (from.path !== '/' && !to.params.number && !to.query.tableNumber && tableNumber) {
    return redirectFrom(to, from, next, `${to.path}${splicingQuery(to, from)}`)
  }
  next()
})

/**
 * Query for splicing urls
 * @param {Object} to From routing information
 * @param {Object} from Routing information
 * @returns {String} Query of spliced urls
 */
/**
 * 拼接 url 的 query
 * @param {Object} to 来自路由信息
 * @param {Object} from 去往路由信息
 * @returns {String} 拼接好的 url 的 query
 */
function splicingQuery(to, from) {
  let query = ''
  if (to.query) {
    let num = 0
    // Splicing query
    // 拼接 query
    for (const key in to.query) {
      if (to.query[key] && to.query[key] !== 0 && to.query[key] !== false) {
        num ? query += '&' : query += '?'
        query += `${key}=${to.query[key]}`
        num++
      }
    }
  }
  // If the following query is included in the from url, this parameter will be taken with each jump
  // 若 from url 中带有下面 query，则每次跳转都带走此参数
  if (from.query.enableThirdTest && !to.query.enableThirdTest) query = query + (query ? '&' : '?') + 'enableThirdTest=true'
  if ((('ta' in from.query) && !('ta' in to.query))) query = query + (query ? '&' : '?') + 'ta'
  if (from.query.portal && !to.query.portal) query = query + (query ? '&' : '?') + 'portal=' + from.query.portal
  const tableNumber = store.state?.venueHome?.routerInfo?.number || from?.query?.tableNumber || ''
  if (from.path !== '/' && !to.params.number && !to.query.tableNumber && tableNumber) query = query + (query ? '&' : '?') + 'tableNumber=' + tableNumber

  return query
}

// Domain name jump judgment function. If the current domain name is co, it will automatically jump to the domain name of com
// 域名跳转判断函数。若当前是 'co' 的域名，就自动跳转到 'com' 的域名
async function jumpDomainName() {
  // Skip the legacy .co → .com migration when source and destination are the same origin.
  // Otherwise branch 1 below fires on every navigation and reloads the page in a loop.
  if (process.env.VUE_APP_CUSTOM_BASE_URL === process.env.VUE_APP_CUSTOM_BASE_NEW_URL) return
  const isProduction = process.env.VUE_APP_CUSTOM_BASE_URL === location.origin
  if (isProduction) {
    // Save all local cached data to localStorageData
    // 将本地缓存数据都存到 'localStorageData'
    const localStorageData = {}
    _.forEach(localStorage, (item, index) => {
      const key = localStorage.key(index)
      localStorageData[key] = localStorage.getItem(key)
    })

    // Delete unimportant data in vuex data. In case the data is too large to upload to the server
    // 删除 vuex 数据中不重要的数据。以防由于数据太大，无法将数据上传到服务器的问题出现。
    if (localStorageData.vuex) {
      const vuex = JSON.parse(localStorageData.vuex)
      _.forEach(vuex, (item, key) => {
        if (_.isEmpty(item)) delete vuex[key]
      })
      localStorageData.vuex = vuex
    }
    // Automatically generate id
    // 自动生成 id
    const localStorageId = _generateUuidOrderId()
    // If browser cache exists, call the interface to transfer the cache to the database
    // 若存在浏览器缓存，就调用接口把缓存传到数据库
    if (!_.isEmpty(localStorageData)) {
      await otherAction({
        action: 'save_temp_info',
        data: localStorageData,
        id: localStorageId
      }).catch(e => {
        console.log(e)
      })
    }
    // When jumping to the domain name of com, the original parameters of the url are transferred to the new address. If userId and newVuexData exist, the userId will also be transferred to the new address.
    // 跳转到 'com' 的域名时，把 url 原有的参数传到新地址。若存在 userId 和 newVuexData，就把 userId 也传到新地址。
    window.location.href = `${process.env.VUE_APP_CUSTOM_BASE_NEW_URL + window.location.pathname + window.location.search + (!_.isEmpty(localStorageData) ? `${window.location.search ? '&' : '?'}localStorageId=${localStorageId}` : '')}`
  }

  const isMondomenuCom = process.env.VUE_APP_CUSTOM_BASE_NEW_URL === location.origin
  if (isMondomenuCom) { // get into https://www.mondomenu.com Operation of page   // 进入 https://www.mondomenu.com 页面的操作
    // Save all local cached data to localStorageData
    // 将本地缓存数据都存到 'localStorageData'
    const localStorageId = getUrlParam('localStorageId')
    // If the url has a localStorageId, call the interface to obtain data according to the localStorageId in the url
    // url 存在 localStorageId，就根据 url 中的 localStorageId，调取接口获取数据
    if (localStorageId && localStorage.length <= 5) {
      const res = await otherAction({
        action: 'retrive_temp_info',
        data: '',
        id: localStorageId
      }).catch(e => {
        console.log(e)
      })
      // Save the data obtained from the interface to the browser cache
      // 将接口获取的数据，都存到浏览器缓存
      if (!_.isEmpty(res)) {
        _.forEach(res, (item, key) => {
          let data = item
          // If it is vuex data, it needs to be converted to json and stored locally
          // 若是 vuex 数据，需要转成 json 再存入本地
          if (key === 'vuex') data = JSON.stringify(item)
          localStorage.setItem(key, data)
        })
        // If there is vuex, save it as well
        // 若存在 vuex，也要保存 vuex
        if (!_.isEmpty(res.vuex)) store.commit('saveVuex', res.vuex)
      }
      const url = window.location.href.replace(`localStorageId=${localStorageId}`, '') // After the judgment, the url is remade, and the localStorageId parameter is changed after the page is refreshed   // 判断之后，重置 url，让页面刷新之后更改 localStorageId 参数
      window.history.pushState({}, 0, url) // Do not jump to rewrite url   // 不跳转重写 url
    }
  }
}

export default router
